'use strict';

angular.module('loginModule', [
    'ngKomondorAccess',
    'ngKomondorMediaLibrary'
]);
